import { Component, Vue } from 'vue-property-decorator';
import { MiDialogOptions } from '@/components/MiDialog/MiDialog';
import Navigation, { NavigationItem } from '@/components/Navigation/Navigation.vue';

@Component<App>({
  components: {
    Navigation,
  },
})

export default class App extends Vue {
  protected isLoading = true;

  protected mounted(): void {
    setTimeout(() => {
      // Simulate loading since nothing exciting happens yet.
      this.isLoading = false;
    }, 500);
  }

  protected get showNavigation(): boolean {
    return !! this.$route.meta?.auth;
  }

  protected get menuItems(): NavigationItem[] {
    if (! this.$store.getters.currentUser) {
      return [];
    }

    if (this.$store.getters.isContractor) {
      return this.contractorMenuItems;
    }

    if (this.$store.getters.isBureau) {
      return this.bureauMenuItems;
    }

    return [];
  }

  public get contractorMenuItems(): NavigationItem[] {
    return [
      { title: 'Startpagina', to: '/dashboard' },
      { title: 'Mijn Opdrachten', to: '/reports' },
      { title: 'Bibliotheek', to: '/library' },
    ];
  }

  public get bureauMenuItems(): NavigationItem[] {
    return [
      { title: 'Startpagina', to: '/dashboard' },
      { title: 'Opdrachten', to: '/reports' },
      { title: 'Herstelbedrijven', to: '/contractors' },
      { title: 'Bibliotheek', to: '/library' },
      { title: 'Rapportage', to: '/rapportage' },
    ];
  }

  protected get dialogOptions(): MiDialogOptions | null {
    return this.$store.getters.generalDialogOptions;
  }

  protected get isDisplayingDialog(): boolean {
    return this.dialogOptions !== null;
  }

  protected set isDisplayingDialog(value: boolean) {
    this.$store.dispatch('closeDialog');
  }
}
